import React from 'react';
import './CTASection.css';

const CTASection = ({
  title,
  subtitle,
  buttonText,
  onButtonClick
}) => {
  const defaultClick = () => {
    window.open(
      'https://wa.me/601163688943?text=Hi%2C%20I%20would%20like%20to%20get%20started%20with%20SAPOT%20AI',
      '_blank'
    );
  };

  return (
    <div className="cta-block-wrapper">
      <div className="cta-block">
        <div className="cta-block__content">
          <h2 className="cta-block__title">{title}</h2>
          <p className="cta-block__subtitle">{subtitle}</p>
          <button className="cta-block__button" onClick={onButtonClick || defaultClick}>
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CTASection;
